import * as __WEBPACK_EXTERNAL_MODULE__sentry_react_386a9dc1__ from "@sentry/react";
const DEFAULT_QUEUE_LIMIT = 6;
class LimitQueue {
    limit;
    items;
    currentIndex;
    constructor(limit = DEFAULT_QUEUE_LIMIT){
        this.limit = limit;
        this.items = [];
        this.currentIndex = 0;
    }
    addItem(item) {
        this.items.unshift(item);
        this.items = this.items.slice(0, this.limit);
    }
    getItems() {
        return this.items;
    }
}
const pushRequestIdToSentry = (sentryEnabled, limit)=>{
    const sentryRequestQueue = new LimitQueue(limit);
    return (requestId)=>{
        if (sentryEnabled && requestId) {
            const requestIdArray = requestId.split(',').map((item)=>item.trim());
            const uniqueRequestId = [
                ...new Set(requestIdArray)
            ].join(', ');
            sentryRequestQueue.addItem(uniqueRequestId);
            __WEBPACK_EXTERNAL_MODULE__sentry_react_386a9dc1__.getCurrentScope().setExtra('lastAsyncRequestIds', sentryRequestQueue.getItems());
        }
    };
};
const pushRequestIdToSentry_rslib_entry_ = pushRequestIdToSentry;
export { pushRequestIdToSentry_rslib_entry_ as default };

//# sourceMappingURL=pushRequestIdToSentry.mjs.map